import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import * as z from 'zod';
import type {CreateManualMealCommand} from '../../domain/create-manual-meal-command';
import {MEAL_TYPES} from '../../domain/meal-type.value-object';
import {MANUAL_MEAL_MAX_ENTRIES} from '../../lib/constants';
import {isLocalDate} from '../../lib/local-date';
import {ManualMealEntryDataValidator} from './manual-meal-entry-data.validator';

export class CreateManualMealCommandValidator implements Validator<CreateManualMealCommand> {
  private static readonly entry = new ManualMealEntryDataValidator();

  readonly standardSchema = z.strictObject({
    mealType: z.enum(MEAL_TYPES),
    nutritionDate: z
      .string()
      .refine(isLocalDate, {message: 'Date must be formatted as YYYY-MM-DD.'})
      .optional(),
    consumedAt: z.iso.datetime({offset: true}).optional(),
    entries: z
      .array(CreateManualMealCommandValidator.entry.standardSchema)
      .min(1)
      .max(MANUAL_MEAL_MAX_ENTRIES),
  });

  validate(value: unknown): Result<CreateManualMealCommand, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);

    if (!parsed.success) {
      return err(
        new ValidationError(parsed.error.issues[0]?.message ?? 'Invalid create manual meal body.'),
      );
    }

    return ok(parsed.data);
  }
}
